import { createStructuredSelector } from 'reselect';

export const selectProgress = state => state.errorTemplateNotActive.refreshInProgress;
export const selectStatus = state => state.errorTemplateNotActive.newLinkSent;

export default createStructuredSelector({
  refreshInProgress: selectProgress,
  newLinkSent: selectStatus,
});
